/**
 * Best-effort persistence of small UI preferences (the author's name on feedback entries).
 *
 * Wrapped because localStorage is NOT always there: private browsing, embedded webviews, and a
 * jsdom test environment can each leave it missing or throwing. A convenience that takes the page
 * down when it is unavailable is worse than no convenience — and this crashed a test before it
 * could have crashed a tester.
 */
export const remembered = (key: string): string => {
  try {
    return localStorage.getItem(key) ?? "";
  } catch {
    return "";
  }
};

export const remember = (key: string, value: string): void => {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* preference not persisted; nothing depends on it */
  }
};
